import { Box, Collapse, IconButton, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useState } from "react";
import { format } from "date-fns";
import pt from "date-fns/locale/pt";
import { useInvoiceSchedulesByTreatment } from "../../../../api/moloni/useInvoiceSchedulesByTreatment";
import { getStatusChip } from "./utils";
import { groupSchedulesByWeek, formatScheduleDateWithDay } from "./utils";

type RecentScheduledInvoicesProps = {
    treatmentId: number;
};

const getOrderDate = (order: number | { order_date: string }) => {
    if (typeof order === "object" && order.order_date) {
        return format(new Date(order.order_date), "dd/MM/yyyy", { locale: pt });
    }
    return "-";
};

export const RecentScheduledInvoices = ({ treatmentId }: RecentScheduledInvoicesProps) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const { data: allSchedules, isLoading } = useInvoiceSchedulesByTreatment(treatmentId);

    if (isLoading || !allSchedules || allSchedules.length === 0) {
        return null;
    }

    const sortedSchedules = [...allSchedules].sort((a, b) => {
        const dateA = new Date(a.scheduled_date).getTime();
        const dateB = new Date(b.scheduled_date).getTime();
        return dateB - dateA;
    });

    const last4Schedules = sortedSchedules.slice(0, 4);
    const groupedSchedules = groupSchedulesByWeek(last4Schedules);

    return (
        <Box sx={{ mb: 3, p: 2, backgroundColor: "#f5f5f5", borderRadius: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <IconButton size="small" onClick={() => setIsExpanded(!isExpanded)}>
                    {isExpanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                </IconButton>
                <Typography variant="subtitle1" color="primary" sx={{ fontWeight: 600 }}>
                    Últimas Faturas Agendadas
                </Typography>
            </Box>
            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                {groupedSchedules.map((group, groupIndex) => (
                    <Box key={groupIndex} sx={{ mb: 2 }}>
                        <Typography variant="body2" sx={{ mb: 1, fontWeight: 700, color: "#666" }}>
                            {group.weekLabel}
                        </Typography>
                        {group.schedules.map((schedule) => (
                            <Box
                                key={schedule.id}
                                sx={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    gap: 3,
                                    ml: 2,
                                    mb: 1.5,
                                }}
                            >
                                <Box sx={{ display: "flex", flexDirection: "column", minWidth: 220 }}>
                                    <Typography variant="body2" color="primary" sx={{ mb: 0.5 }}>
                                        Data de agendamento:
                                    </Typography>
                                    <Typography variant="body2">{formatScheduleDateWithDay(schedule.scheduled_date)}</Typography>
                                </Box>
                                <Box sx={{ display: "flex", flexDirection: "column", minWidth: 100 }}>
                                    <Typography variant="body2" color="primary" sx={{ mb: 0.5 }}>
                                        Estado:
                                    </Typography>
                                    {getStatusChip(schedule.status)}
                                </Box>
                                <Box sx={{ display: "flex", flexDirection: "column", minWidth: 120 }}>
                                    <Typography variant="body2" color="primary" sx={{ mb: 0.5 }}>
                                        Data da compra:
                                    </Typography>
                                    <Typography variant="body2">{getOrderDate(schedule.order)}</Typography>
                                </Box>
                            </Box>
                        ))}
                    </Box>
                ))}
            </Collapse>
        </Box>
    );
};

